/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import React, { Component } from 'react'

class MultiCheckbox extends Component {
  constructor(props) {
    super(props)
    this.state = {
      name: this.props.name,
      onChange: this.props.onChange,
      checkList: this.props.checkList,
      selection: this.props.selection
    }
  }

  handleChange(value) {
    let selection = this.state.selection
    let position = selection.indexOf(value)

    if (position === -1) {
      selection.push(value)
    } else {
      selection.splice(position, 1)
    }
    this.setState({ selection: selection })

    const event = {
      target: {
        name: this.state.name,
        value: selection
      }
    }

    this.state.onChange(event)
  }

  render() {
    return this.state.checkList.map(
      function(check, i) {
        return (
          <span key={i}>
            <input type="checkbox" name={this.state.name} checked={this.state.selection.indexOf(check.value) !== -1} onChange={this.handleChange.bind(this, check.value)} />
            {check.label}
          </span>
        )
      }.bind(this)
    )
  }
}

export default MultiCheckbox
